export default __webpack_public_path__ + "static/Mccormick-ced29fc601a8bfbf2a3c663e6e9b023f.jpg";